import { Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { SaveMission } from '../../../store/actions/mission.actions';
import { ConstsHelper } from '../../../../../helpers/consts.helper';
import { ConsumptionInterfaceState } from '../../../../lines/store/state/consumption.state';
import { ConsumptionInterface } from '../../../../lines/models/consumption.interface';
import { environment } from '../../../../../../environments/environment';
import { LineInterface } from '../../../../lines/models/line.interface';
import { PriceDetailsInterface } from '../../../models/price-details.interface';

@Component({
  selector: 'app-recharge-data-prixtel',
  templateUrl: './recharge-data-prixtel.component.html',
  styleUrls: ['./recharge-data-prixtel.component.css'],
  standalone: false
})
export class RechargeDataPrixtelComponent implements OnInit {
  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  @Input()
  priceDetails?: PriceDetailsInterface;

  consumption: ConsumptionInterface = null;
  environment = environment;
  formSubmitted: boolean;

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.formSubmitted = false;
    this.store.pipe(select(ConstsHelper.REDUCER_CONSUMPTION)).subscribe((response: ConsumptionInterfaceState) => {
      if (!(response.consumption instanceof Array) && null !== response.consumption) {
        this.consumption = response.consumption;
      }
    });
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  send() {
    if (this.formSubmitted === false) {
      this.formSubmitted = true;
      this.store.dispatch(new SaveMission({step: 1, phoneNumber: this.line.phoneNumber}, this.procedureCode));
    }
  }

}
